import { v4 as uuidv4 } from "uuid";

export const setUniqueKeys = (arr: Array<any> | undefined = [], key: string | undefined = "id") => {
  return arr?.map((elem) => {
    return { ...elem, [key]: uuidv4() };
  });
};
